import { DebouncedInput } from "@/components/form";
import { RelativeComponentLoader } from "@/components/loader";
import { useState, useMemo } from "react";
import UploadUserGroupsButton from "./UploadUserGroupsButton";
import { NoGroupsImage } from "./assets";
import { isOwner } from "@/services/auth";
import useUserGroups from "./useUserGroups";
import UserGroupItem from "./UserGroupItem";
import AddNewTeam from "./AddNewTeam";
import { Card, Stack, Typography } from "@altimateai/lego";

const UserGroupsList = () => {
  const { total, groups: allGroups, isFetching, isLoading } = useUserGroups();
  const [localSearch, setLocalSearch] = useState("");

  const filteredGroups = useMemo(() => {
    if (!localSearch) return allGroups;
    return allGroups.filter(group => group.name.toLowerCase().includes(localSearch.toLowerCase()));
  }, [allGroups, localSearch]);

  if (!localSearch && !isFetching && !allGroups.length) {
    return (
      <Card className="al-w-full p-4">
        <Stack className="al-justify-center al-items-center" direction="column">
          <NoGroupsImage />
          <h4>No Teams Found</h4>
          <p>Add teams by clicking the button</p>
          <UploadUserGroupsButton />
        </Stack>
      </Card>
    );
  }

  return (
    <Card
      className="p-3"
      style={{
        width: 300,
      }}
      role="region"
      aria-label="Teams List Section"
    >
      <Stack direction="row" justify="between" align="center" className="al-mb-2">
        <Typography variant="section-heading">
          Teams ({localSearch ? filteredGroups.length : total})
        </Typography>
        {isOwner() && <AddNewTeam />}
      </Stack>
      <div className="al-mb-2">
        <DebouncedInput
          size="sm"
          placeholder="Search by team name"
          aria-label="Search by team name"
          onChange={(v: string) => {
            setLocalSearch(v);
          }}
        />
      </div>
      <ul
        className="al-min-h-[420px] al-max-h-[70vh] al-overflow-y-auto al-p-0"
        aria-label="Teams list"
      >
        {isLoading ? (
          <RelativeComponentLoader label="Loading teams..." />
        ) : !filteredGroups.length ? (
          <Typography variant="body" className="text-gray-500">
            No result!
          </Typography>
        ) : (
          filteredGroups.map(group => <UserGroupItem key={group.id} group={group} />)
        )}
      </ul>
    </Card>
  );
};

export default UserGroupsList;
